import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomFieldValueDto } from 'src/app/shared/dto/custom-field-value.dto';
import { FieldTypesEnum } from 'src/app/shared/enums/field-types.enum';
import { BaseService } from 'src/app/shared/services/base.service';

@Injectable({
    providedIn: 'root'
})
export class CustomFieldsValuesService extends BaseService {
    constructor(httpClient: HttpClient) {
        super(httpClient, 'custom-fields-values');
    }

    async findByEntity(entity: string): Promise<CustomFieldValueDto[]> {
        try {
            if (entity == null || entity == '') {
                throw new Error('Entity can not be null');
            }

            const request = this.httpClient.get<CustomFieldValueDto[]>(`${this.url}/findByEntity/${entity}`);

            const customFields = await lastValueFrom(request);

            if (!customFields) {
                throw new Error('No custom fields found');
            }

            return customFields;
        } catch (e: any) {
            throw new Error(`No custom fields values found. Error: ${e.message}`);
        }
    }

    async create(customFieldsValues: CustomFieldValueDto[]): Promise<CustomFieldValueDto[]> {
        try {
            if (customFieldsValues.length === 0) {
                throw new Error('Custom fields values list is empty');
            }

            const createdCustomFields: CustomFieldValueDto[] = await lastValueFrom(this.httpClient.post<CustomFieldValueDto[]>(`${this.url}`, customFieldsValues));

            return createdCustomFields;
        } catch (e: any) {
            throw new Error(`Error updating custom fields values. Error: ${e.message}`)
        }
    }

    private stringToDataType(value: string | number | boolean | string[], dataType: FieldTypesEnum): string | number | boolean | string[] {
        let result: string | number | boolean | string[] = value;

		switch (dataType) {
			case FieldTypesEnum.INPUT_NUMBER:
				result = Number(value);
				break;
			case FieldTypesEnum.CHECKBOX:
				result = value === 'true';
				break;
			case FieldTypesEnum.MULTISELECT:
				result = (value as string).split(',');
				break;
		}

        return result;
    }
}
